const lbaUrl = angular.module('app.lbaUrl', []);

lbaUrl.controller('lbaUrlCtrl', require('./lbaUrlCtrl'));
lbaUrl.directive('lbaUrl', require('./lbaUrlDir'));

export default lbaUrl;



// WEBPACK FOOTER //
// ./src/components/lbaUrl/index.js